import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
// import LoaderButton from '../../loader-button/LoaderButton';
import PropTypes from 'prop-types';
import ProductPriority from '../section/ProductPriority';

import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  FormFeedback,
  Label,
  FormGroup,
  TabContent,
  TabPane,
  Input
} from 'reactstrap';
import ServiceWidget from '../../dashboard/ServiceWidget';
import CardSummary from '../Vendor/CardSummary';
import SummaryModal from '../Vendor/Modal';
import CredsModal from '../Vendor/CredsModal';
import BZAPIService from '../../../services/BZAPIService';
import DefaultConfigTab from '../section/DefaultConfigTab';

import TabNav from '../section/TabNav';
// constants
import SETTINGS from '../../../constants/settings';
import ButtonIcon from '../../common/ButtonIcon';
import { FieldGroup } from '../../../libs/formLib';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ConfigFormMSFT = ({
  isReadOnly,
  vendorLabel,
  bugsDateBack,
  setBugsDateBack,
  vendorId,
  vendorPriorityOptions,
  vendorStatusOptions,
  snCompanySysIdOptions,
  snIntegrationCheck,
  services,
  vendors,
  priorityStats,
  snCompanySysIdErrors,
  setVendorStatuses,
  vendorStatuses,
  fields,
  handleFieldChange,
  priorityMaps,
  setPriorityMaps,
  snPriorityOptions,
  keywords,
  setKeywords,
  searchFields,
  setSearchFields,
  snCompanySysId,
  setSnCompanySysId,
  setServices,
  setVendors,
  buildVendorStat,
  setPriorityStats,
  setBugs,
  isConfigured,
  vendorBugCategories,
  setVendorBugCategories,
  vendorBugCategoryOptions,
  syncOnly,
  setSyncOnly
}) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isValidCredentials, setIsValidCredentials] = useState(false);
  const [isTestingValidCredentials, setIsTestingValidCredentials] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isAddingCredentials, setIsAddingCredentials] = useState(false);

  const [isAddingMFA, setIsAddingMFA] = useState(false);

  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState('1');
  const [modalOpen, setModalOpen] = useState(false);
  const [validated, setValidated] = useState(null);

  function cancelCreds() {
    fields.username = '';
    fields.password = '';
    fields.mfaSecret = '';
    setIsAddingCredentials(false);
  }
  function toggleMFA() {
    fields.mfaSecret = '';
    setIsAddingMFA(!isAddingMFA);
  }

  async function saveServiceAWSSecret() {
    if (fields.mfaSecret.length > 0) {
      const data = {
        secret: {
          username: fields.username,
          password: fields.password,
          mfa_secret: fields.mfaSecret
        },
        vendorId: 'msft',
        key: 'admin'
      };
      return BZAPIService.createOrUpdateAWSSecret(data);
    } else {
      const data = {
        secret: {
          username: fields.username,
          password: fields.password
        },
        vendorId: 'msft',
        key: 'admin'
      };
      return BZAPIService.createOrUpdateAWSSecret(data);
    }
  }

  async function testCreds() {
    setIsTestingValidCredentials(true);
    if (fields.mfaSecret.length > 0) {
      const data = {
        username: fields.username,
        password: fields.password,
        mfa_secret: fields.mfaSecret
      };
      console.log('data', data);
      const result = await BZAPIService.vendorTestCreds(vendorId, data);
      setIsTestingValidCredentials(false);
      if (result && result.completed) {
        // valid creds
        setIsValidCredentials(true);
        setIsAddingCredentials(false);
        toast.success(`Credentials validated!`);
      } else {
        toast.error('Error Validating credentials.');
      }

      console.log('result', result);
    } else {
      const data = {
        username: fields.username,
        password: fields.password
      };
      console.log('data', data);
      const result = await BZAPIService.vendorTestCreds(vendorId, data);
      setIsTestingValidCredentials(false);
      if (result && result.completed) {
        // valid creds
        setIsValidCredentials(true);
        setIsAddingCredentials(false);
        toast.success(`Credentials validated!`);
      } else {
        toast.error('Error Validating credentials.');
      }

      console.log('result', result);
    }
  }

  async function saveConfig(serviceSecret) {
    console.log('saveConfig', fields);
    const vendorPriorities = priorityMaps.map(mapping => {
      return {
        value: mapping.vendorPriority.value,
        label: mapping.vendorPriority.value,
        snPriority: mapping.snPriority.value
      };
    });

    const data = {
      secretId: serviceSecret.Name,
      bugsDateBack: bugsDateBack,
      snCompanySysId: snCompanySysId.value ? snCompanySysId.value : fields.snCompanySysId,
      snAffectedCIQuery: fields.snAffectedCIQuery,
      vendorPriorities,
      vendorStatuses,
      type: SETTINGS.VENDOR,
      excludedKws: keywords,
      searchFields: searchFields,
      vendorBugCategories
    };

    return BZAPIService.saveSetting(vendorId, syncOnly, data);
  }

  async function handleSave() {
    try {
      setIsLoading(true);
      setIsSubmitted(true);

      // Validate Secrets

      if (!fields.secretId) {
        if (!fields.username || !fields.password) {
          console.log('missing secret');
          setValidated(false);
          setIsLoading(false);
          return;
        }
      }

      // Validate
      if (
        !bugsDateBack.length ||
        !snCompanySysId ||
        !priorityMaps.length ||
        !vendorStatuses.length ||
        !vendorBugCategories.length
      ) {
        console.log('error');
        setValidated(false);
        setIsLoading(false);
        return;
      }

      let serviceSecret;

      if (fields.password && fields.username) {
        // Updated secrets
        serviceSecret = await saveServiceAWSSecret();
      } else {
        // use existing secrets
        serviceSecret = { Name: fields.secretId };
      }
      console.log('serviceSecret', serviceSecret);
      if (!serviceSecret || !serviceSecret.Name) {
        setIsLoading(false);
        setValidated(false);
        throw Error('Missing Secret');
      }
      await saveConfig(serviceSecret);
      fields.secretId = serviceSecret.Name;

      setIsLoading(false);
      setIsSubmitted(false);
      setModalOpen(false);
      toast.success(`Settings Saved!`);
    } catch (e) {
      setIsLoading(false);
      toast.error('Failed to save.');
      console.log('e', e);
    }
  }

  return (
    <>
      <TabNav
        vendorId={vendorId}
        credentials={true}
        activeTab={activeTab}
        snIntegrationCheck={snIntegrationCheck}
        setActiveTab={setActiveTab}
        setIsLoading={setIsLoading}
        isLoading={isLoading}
        setServices={setServices}
        setVendors={setVendors}
        buildVendorStat={buildVendorStat}
        setPriorityStats={setPriorityStats}
        setBugs={setBugs}
        isConfigured={isConfigured}
      />

      <TabContent>
        <div style={{ minWidth: '100%' }}>
          <TabPane tabId="1">
            {activeTab === '1' && (
              <Card bg={'light'} text={'dak'} className="mb-4">
                {/* <FalconCardHeader title="Statistics" /> */}
                <CardBody>
                  {!snIntegrationCheck ? (
                    <>
                      <p className="text-center">Please setup your ServiceNow integration.</p>
                      <div className="text-center">
                        <Link className="btn btn-falcon-primary text-center" to="/integrations/servicenow">
                          Setup now
                        </Link>
                      </div>
                    </>
                  ) : (
                    <Row>
                      <Col>
                        {services.map(service => {
                          let color = 'warning';
                          switch (service.status) {
                            case 'OPERATIONAL':
                              color = 'green';
                              break;
                            case 'NOT CONFIGURED':
                            case 'PENDING':
                              color = 'blue';
                              break;
                            case 'ERROR':
                              color = 'red';
                              break;
                            case 'RUNNING':
                              color = 'light-blue';
                              break;
                            default:
                              break;
                          }
                          return service.id === vendorId + '-bs' ? (
                            <CardSummary
                              key={service?.name}
                              title={service?.status}
                              color={color}
                              linkText="View"
                              to={service?.vendorId}
                              message={service?.message}
                              activeTab={activeTab}
                              setActiveTab={setActiveTab}
                              errors={service?.vendorData?.errors}
                              timestamp={service?.vendorData?.timestamp}
                            >
                              {service?.name?.replace('Systems', 'Networks')}
                            </CardSummary>
                          ) : (
                            ''
                          );
                        })}
                      </Col>
                      <Col>
                        {vendors.length &&
                          vendors.map((vendor, key) => {
                            return vendor.id === vendorId ? (
                              <div key={key} className="mb-3 pr-md-2">
                                <ServiceWidget
                                  data={priorityStats[vendor.id] || []}
                                  title={
                                    'Bugs found in the last 7 days for ' + vendor?.name?.replace('Systems', 'Networks')
                                  }
                                />
                              </div>
                            ) : (
                              ''
                            );
                          })}
                      </Col>
                    </Row>
                  )}
                </CardBody>
              </Card>
            )}
          </TabPane>
        </div>
        <form noValidate style={{ minWidth: '100%' }}>
          <input type="hidden" value="prayer" />
          <TabPane tabId="2">
            {activeTab === '2' && (
              <Card bg={'light'} text={'dak'} className="mb-4">
                {/* <FalconCardHeader title="Vendor settings" /> */}
                <CardBody>
                  <Row form>
                    <Col lg="12">
                      <FormGroup>
                        <Label>
                          Microsoft Admin Credentials
                          <span style={{ color: '#bd472a' }}>*</span>
                        </Label>
                        {!isAddingCredentials ? (
                          <>
                            <div>
                              <ButtonIcon
                                onClick={() => setIsAddingCredentials(true)}
                                color="falcon-default"
                                size="sm"
                                icon="plus"
                                iconClassName="fs--2"
                              >
                                Set Credentials
                              </ButtonIcon>
                              {/* <Button variant="outline-primary" onClick={() => setIsAddingCredentials(true)}>
                          <FontAwesomeIcon icon={'plus'} /> Set Credentials
                        </Button> */}

                              {fields.secretId || isValidCredentials ? (
                                <>
                                  {'  '}
                                  <FontAwesomeIcon icon={'check'} style={{ color: 'green', marginLeft: '10px' }} />{' '}
                                  Microsoft Credentials Stored
                                </>
                              ) : null}
                            </div>
                          </>
                        ) : (
                          <>
                            <Row>
                              <Col lg="6">
                                <FieldGroup
                                  type="text"
                                  id="username"
                                  onChange={handleFieldChange}
                                  value={fields.username}
                                  label={'Microsoft Admin Username'}
                                  showFeedback={!isValidCredentials}
                                  feedback={'Username has not been validated or is invalid.'}
                                  placeholder="Enter Microsoft Admin Username"
                                  style={{ marginBottom: '10px' }}
                                  required
                                />
                              </Col>
                              <Col lg="6">
                                <FieldGroup
                                  type="password"
                                  id="password"
                                  autoComplete="new-password"
                                  onChange={handleFieldChange}
                                  value={fields.password}
                                  label={'Microsoft Admin Password'}
                                  showFeedback={!isValidCredentials}
                                  feedback={'Password has not been validated or is invalid.'}
                                  placeholder="Enter Microsoft Admin Password"
                                  style={{ marginBottom: '10px' }}
                                  required
                                />
                              </Col>
                            </Row>
                            <Row form>
                              <Col lg="12">
                                <FormGroup>
                                  <Col>
                                    <div className="ml-1">
                                      <Input onChange={toggleMFA} type="checkbox" checked={isAddingMFA} />
                                      <Label check>Set Multi-factor Authentication Credentials</Label>
                                    </div>
                                  </Col>

                                  {!isAddingMFA ? (
                                    <Col>
                                      <div>
                                        {fields.mfaSecret || isValidCredentials ? (
                                          <>
                                            {'  '}
                                            <FontAwesomeIcon
                                              icon={'check'}
                                              style={{ color: 'green', marginLeft: '10px' }}
                                            />{' '}
                                            Microsoft MFA Stored
                                          </>
                                        ) : null}
                                      </div>
                                    </Col>
                                  ) : (
                                    <>
                                      <Row>
                                        <Col lg="6">
                                          <FieldGroup
                                            type="text"
                                            id="mfaSecret"
                                            onChange={handleFieldChange}
                                            value={fields.mfaSecret}
                                            label={'Microsoft MFA Secret'}
                                            showFeedback={!isValidCredentials}
                                            feedback={'MFA Secret has not been validated or is invalid.'}
                                            placeholder="Enter MFA Secret"
                                            style={{ marginBottom: '10px' }}
                                          />
                                        </Col>
                                      </Row>
                                    </>
                                  )}
                                  <FormFeedback
                                    className={!fields.secretId && !fields.refreshToken && isSubmitted ? 'd-block' : ''}
                                    type="invalid"
                                  >
                                    Please specify credentials.
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                            </Row>
                            <CredsModal
                              isTestingValidCredentials={isTestingValidCredentials}
                              setIsTestingCredentials={setIsTestingValidCredentials}
                              fields={fields}
                              testCreds={testCreds}
                              vendorId={vendorId}
                            />
                            {/* <LoaderButton
                              isLoading={isTestingValidCredentials}
                              onClick={e =>
                                !fields.username.length || !fields.password.length
                                  ? console.log('missing credentials')
                                  : testCreds()
                              }
                              color="falcon-default"
                              size="sm"
                              icon="check"
                              iconclassname="fs--2"
                              style={{ marginRight: '10px' }}
                            >
                              Test and update
                            </LoaderButton>{' '} */}
                            <ButtonIcon
                              onClick={cancelCreds}
                              color="falcon-default"
                              size="sm"
                              icon="times"
                              iconclassname="fs--2"
                              style={{ marginRight: '10px' }}
                            >
                              Cancel
                            </ButtonIcon>
                          </>
                        )}
                        <FormFeedback
                          className={!fields.secretId && !fields.refreshToken && isSubmitted ? 'd-block' : ''}
                          type="invalid"
                        >
                          Please specify credentials.
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            )}
          </TabPane>

          <DefaultConfigTab
            activeTab={activeTab}
            vendorLabel={vendorLabel}
            bugsDateBack={bugsDateBack}
            setBugsDateBack={setBugsDateBack}
            isSubmitted={isSubmitted}
            snCompanySysIdErrors={snCompanySysIdErrors}
            snCompanySysIdOptions={snCompanySysIdOptions}
            setSnCompanySysId={setSnCompanySysId}
            snCompanySysId={snCompanySysId}
            fields={fields}
            handleFieldChange={handleFieldChange}
          />

          <TabPane tabId="4">
            {activeTab === '4' && (
              <ProductPriority
                title="Default Bug Configuration"
                vendorPriorityOptions={vendorPriorityOptions}
                vendorStatusOptions={vendorStatusOptions}
                setVendorStatuses={setVendorStatuses}
                vendorStatuses={vendorStatuses}
                isSubmitted={isSubmitted}
                priorityMaps={priorityMaps}
                setPriorityMaps={setPriorityMaps}
                snPriorityOptions={snPriorityOptions}
                keywords={keywords}
                setKeywords={setKeywords}
                searchFields={searchFields}
                setSearchFields={setSearchFields}
                vendorBugCategories={vendorBugCategories}
                setVendorBugCategories={setVendorBugCategories}
                vendorBugCategoryOptions={vendorBugCategoryOptions}
              />
            )}
          </TabPane>
          <Row className={`${activeTab === '1' ? 'd-none' : ''} flex-between-center`}>
            <Col xs="auto">
              <Button
                block
                color="falcon-danger"
                onClick={() => {
                  console.log(`/vendors/${vendorId}/configuration`);
                  navigate(-1);
                }}
              >
                Cancel
              </Button>
            </Col>
            <Col xs="auto">
              <SummaryModal
                modalOpen={modalOpen}
                isReadOnly={isReadOnly}
                setModalOpen={setModalOpen}
                handleSave={handleSave}
                isLoading={isLoading}
                vendorLabel={vendorLabel?.replace('Systems', 'Networks')}
                vendorId={vendorId}
                validated={validated}
                setValidated={setValidated}
                isAddingCredentials={isAddingCredentials}
                syncOnly={syncOnly}
                setSyncOnly={setSyncOnly}
              />
            </Col>
          </Row>
        </form>
      </TabContent>
    </>
  );
};
ConfigFormMSFT.propTypes = {
  vendor: PropTypes.object,
  isReadOnly: PropTypes.bool,
  settings: PropTypes.object,
  vendorLabel: PropTypes.string,
  vendorId: PropTypes.string,
  vendorPriorityOptions: PropTypes.array,
  vendorStatusOptions: PropTypes.array,
  vendorResolutionOptions: PropTypes.array,
  snIntegrationCheck: PropTypes.bool,
  services: PropTypes.array,
  vendors: PropTypes.array,
  bugs: PropTypes.object,
  priorityStats: PropTypes.object,
  setPriorityStats: PropTypes.func,
  bugOptions: PropTypes.array,
  selectedBugOption: PropTypes.object,
  setSelectedBugOption: PropTypes.func,
  snCompanySysIdOptions: PropTypes.object,
  snCompanySysIdErrors: PropTypes.bool,
  vendorEventScopes: PropTypes.array,
  setVendorEventScopes: PropTypes.func,
  vendorResolutions: PropTypes.array,
  setVendorResolutions: PropTypes.func,
  setVendorStatuses: PropTypes.func,
  vendorStatuses: PropTypes.array,
  fields: PropTypes.object,
  handleFieldChange: PropTypes.func,
  priorityMaps: PropTypes.array,
  setPriorityMaps: PropTypes.func,
  snPriorityOptions: PropTypes.array,
  keywords: PropTypes.array,
  setKeywords: PropTypes.func,
  searchFields: PropTypes.array,
  setSearchFields: PropTypes.func,
  setSnCompanySysId: PropTypes.func,
  snCompanySysId: PropTypes.object,
  bugsDateBack: PropTypes.string,
  setBugsDateBack: PropTypes.func,
  setServices: PropTypes.func,
  setVendors: PropTypes.func,
  buildVendorStat: PropTypes.func,
  setBugs: PropTypes.func,
  isConfigured: PropTypes.bool,
  vendorBugCategories: PropTypes.array,
  setVendorBugCategories: PropTypes.func,
  vendorBugCategoryOptions: PropTypes.array,
  syncOnly: PropTypes.bool,
  setSyncOnly: PropTypes.func
};
export default ConfigFormMSFT;
